import React from 'react';
import { Divider } from '@mui/material';
import { Color } from './types';
import { DesktopMessagingContent, DesktopMessagingDialog } from './MessagingModal/DesktopMessagingDialog';
import { DesktopMessagingToDosContent, MobileMessagingToDosContent } from './ToDos/MessagingToDosContent.component';
import { MobileMessagingContent, MobileMessagingDialog } from './MessagingModal/MobileMessagingDialog';
import { useFeatureFlag, useIsMobile } from '@uplift/hooks';
import { useMessagingContext } from './MessagingProvider.component';


export type MessagingModalProps = {
  color: Color;
};


export const ProviderDesktopMessagingModal: React.FC<MessagingModalProps> = (props) => {
  const { tab, setTab } = useMessagingContext();

  return (
    <DesktopMessagingDialog>
      <Divider />
      {tab === 'messages' && (
        <DesktopMessagingContent
          color={props.color}
          onOpenToDosClick={() => setTab('todos')}
          includeToDos={true}
        />
      )}
      {tab === 'todos' && (
        <DesktopMessagingToDosContent
          onBack={() => setTab('messages')}
        />
      )}
    </DesktopMessagingDialog>
  );
};


export const ProviderMobileMessagingModal: React.FC<MessagingModalProps> = (props) => {
  const { tab, setTab } = useMessagingContext();

  return (
    <MobileMessagingDialog>
      {tab === 'messages' && (
        <MobileMessagingContent
          color={props.color}
          onOpenToDosClick={() => setTab('todos')}
          includeToDos={true}
        />
      )}
      {tab === 'todos' && (
        <MobileMessagingToDosContent
          onBack={() => setTab('messages')}
        />
      )}
    </MobileMessagingDialog>
  );
};


export const ProviderMessagingModal: React.FC = () => {
  const ff = useFeatureFlag('IN_APP_MESSAGING');
  const isMobile = useIsMobile();

  if (!ff) return null;

  if (isMobile) {
    return <ProviderMobileMessagingModal color="secondary" />;
  }

  return <ProviderDesktopMessagingModal color="secondary" />;
};
